import axios from 'axios';

// create an axios instance
const baseURL = process.env.VUE_APP_BASE_API_DOMAIN_PLATFORM;

const request = axios.create({
  baseURL,
  timeout: 30000, // request timeout
});

// 请求拦截
request.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    // Toast.show({
    //   content: error,
    // });
    console.log('axios', error); // for debug
    return Promise.reject(error);
  },
);

// 响应拦截
request.interceptors.response.use(
  (response) => {
    const res = response.data;
    if (res.code !== undefined) {
      if (res.code !== 0) {
        // Toast.show({
        //   content: res.msg,
        // });
        return Promise.reject(res);
      }
      return res;
    } else {
      return response;
    }
  },
  (error) => {
    // Toast.show({
    //   content: error,
    // });
    return Promise.reject(error);
  },
);

export default request;
